import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, formatMessage } from 'react-intl'
import ReactAvatarEditor from 'react-avatar-editor'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import $ from 'jquery'
import { dynamicImageFeedback } from '../../../actions/ImageUpload'
import { changeProfilePicInitialEditState } from '../../../actions/Edit'
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@vmockinc/dashboard/Common/commonComps/Modal'
import FocusLock from 'react-focus-lock'
import classNames from 'classnames'
import { notification } from '../../../services/helpers'
import { iconMap, feedbackMap } from '../../Constants/ProfilePictureFeedback'
import { editModalAriaLabel } from '../../Constants/AriaLabelText'
import _ from 'underscore'
import { downloadImage } from '../../../actions/ImageUpload'

class ImageEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: 100,
      width: 200,
      height: 200,
      containerHeight: 300,
      canvasWidth: 500,
      brightness: 1,
      contrast: 1,
      editMade: null,
      getNewFeedback: false,
      resetClicked: false,
      isUploaded: true,
      initialFeedback: null,
      face_frame_ratio_open: false,
      face_body_ratio_open: false,
      background_open: false,
      foreground_open: false,
      pupil_open: false,
      smile_open: false,
    }
    this.downloadImage = this.downloadImage.bind(this)
    this.handleScale = this.handleScale.bind(this)
    this.handleRotate = this.handleRotate.bind(this)
    this.setEditorRef = this.setEditorRef.bind(this)
    this.toggleInfoBox = this.toggleInfoBox.bind(this)
    this.handlePositionChange = this.handlePositionChange.bind(this)
    this.handleRotateStraighten = this.handleRotateStraighten.bind(this)
    this.handleBrightness = this.handleBrightness.bind(this)
    this.handleContrast = this.handleContrast.bind(this)
    this.handleReset = this.handleReset.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFile = this.handleFile.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleScreenResize = this.handleScreenResize.bind(this)
    this.handleImgInfoClose = this.handleImgInfoClose.bind(this)
    this.straightenerValue = 0
    this.trackNotifyError = _.debounce(this.trackProcess, 2000, true)
    this.trackRotateClick = _.debounce(this.trackUserClick, 5000, true)
    this.trackZoomClick = _.debounce(this.trackUserClick, 5000, true)
    this.trackBrightness = _.debounce(this.trackUserClick, 5000, true)
    this.trackContrast = _.debounce(this.trackUserClick, 5000, true)
    this.trackStraighten = _.debounce(this.trackUserClick, 5000, true)
    this.trackPositionChange = _.debounce(this.trackUserClick, 5000, true)
    this.trackReset = _.debounce(this.trackUserClick, 5000, true)
    this.trackUpload = _.debounce(this.trackUserClick, 5000, true)
    this.trackChangePhoto = _.debounce(this.trackUserClick, 5000, true)
    this.trackNewPhotoAdded = _.debounce(this.trackUserClick, 5000, true)
    this.debounceDynamicFeedback = _.debounce(
      this.getDynamicFeedback,
      2000,
      false
    )
    this.canvasFilterStyle = `brightness(1) contrast(1)`
    this.currentFeedback = null
    this.featuresNotDetected = false
    this.initialFeedbackToShow = true
    this.initialFeaturesNotDetected = false
  }

  trackUserClick(tag) {
    sendTrackingData('event', 'aspire_edit_screen', 'click', tag)
  }

  trackProcess(tag) {
    sendTrackingData('process', 'aspire_edit_screen', 'notify_error', tag)
  }

  downloadImage(url) {
    const { downloadImage, intl } = this.props
    downloadImage(url, intl)
  }

  dataURItoBlob(dataURI) {
    if (_.isEmpty(dataURI)) {
      return null
    }
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1])
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length)

    // create a view into the buffer
    var ia = new Uint8Array(ab)

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString })
    return blob
  }

  getDynamicFeedback() {
    const { dynamicImageFeedback, intl } = this.props
    const dataURI = this.editor.getImageScaledToCanvas().toDataURL()
    const img = this.dataURItoBlob(dataURI)
    const formData = new FormData()
    formData.append('profile_picture', img)
    dynamicImageFeedback(formData, intl)
    this.setState({
      editMade: true,
      getNewFeedback: false,
      resetClicked: false,
    })
    this.props.handleEditMade(true)
  }

  setEditorRef(editor) {
    if (editor) this.editor = editor
  }

  componentDidMount() {
    const { initialFeedback } = this.props
    $(document).ready(function () {
      $('canvas').on('drop', function () {
        return false
      })
    })

    this.initialFeaturesNotDetected = !_.isEmpty(initialFeedback[1][1])
    this.currentFeedback = this.getFeedbackTiles(true)
    window.addEventListener('resize', this.handleScreenResize)
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      'image_editor_open'
    )
    let el = document.getElementById('picture-canvas-container')
    if (el && el.clientWidth) {
      let canvasWidth = el.clientWidth > 500 ? 500 : el.clientWidth - 0.5
      let containerHeight = canvasWidth * (6 / 10)
      this.setState({
        canvasWidth,
        containerHeight,
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { img } = this.props
    if (nextProps.img !== img) {
      this.handleReset(false)
    }
    return true
  }
  componentDidUpdate(prevProps, prevState) {
    const { feedback } = this.props
    if (
      (!prevProps.isOpen && this.props.isOpen) ||
      prevProps.feedback !== feedback
    ) {
      if (!prevProps.isOpen && this.props.isOpen) {
        setTimeout(() => {
          this.handleScreenResize()
        }, 10)
      }
      this.currentFeedback = this.getFeedbackTiles(true)
    }
    let myStringArray = [
      'face_frame_ratio_open',
      'face_body_ratio_open',
      'background_open',
      'foreground_open',
      'pupil_open',
      'smile_open',
    ]
    let classStateMap = {
      face_frame_ratio_open: 'face-frame-ratio-green-desc',
      face_body_ratio_open: 'face-body-ratio-green-desc',
      background_open: 'background-green-desc',
      pupil_open: 'pupil-green-desc',
      foreground_open: 'foreground-green-desc',
      smile_open: 'smile-green-desc',
    }
    myStringArray.forEach((item, index) => {
      if (prevState[item] !== this.state[item]) {
        let elem = document.getElementsByClassName(classStateMap[item])
        let classSuffix = this.state[item] ? 'open' : 'close'
        if (elem.length > 0) {
          elem[0].className =
            'profile-picture-status-desc ' +
            classStateMap[item] +
            ' profile-picture-status-desc-' +
            classSuffix
        }
      }
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScreenResize)
  }

  handleScreenResize() {
    let el = document.getElementById('picture-canvas-container')
    if (el && el.clientWidth) {
      let canvasWidth = el.clientWidth > 500 ? 500 : el.clientWidth - 0.5
      let containerHeight = canvasWidth * (6 / 10)
      this.setState({
        canvasWidth,
        containerHeight,
      })
    }
  }

  handlePositionChange(position) {
    this.setState({ position, editMade: true, getNewFeedback: true })
    this.props.handleEditMade(true)
    this.debounceDynamicFeedback()
    this.trackPositionChange('image_position_adjusted')
  }

  handleScale(e) {
    const scale = parseFloat(e.target.value)
    this.setState({ scale, editMade: true, getNewFeedback: true })
    this.props.handleEditMade(true)
    this.debounceDynamicFeedback()
    this.trackZoomClick('image_zoom_adjusted')
  }

  handleRotateStraighten(e) {
    const currentScale = parseFloat(e.target.value)
    let rotate = this.state.rotate
    let previousScale = this.straightenerValue
    let degree = currentScale - previousScale
    rotate = rotate + degree
    this.straightenerValue = currentScale
    this.setState({ rotate: rotate, editMade: true, getNewFeedback: true })
    this.props.handleEditMade(true)
    this.debounceDynamicFeedback()
    this.trackStraighten('image_straighten')
  }

  handleRotate(position) {
    let rotate = this.state.rotate
    if (position == 'left') {
      rotate = rotate - 90
    } else {
      rotate = rotate + 90
    }
    rotate %= 360
    rotate = rotate < 0 ? rotate + 360 : rotate

    this.setState({ rotate: rotate, editMade: true, getNewFeedback: true })
    this.props.handleEditMade(true)
    this.debounceDynamicFeedback()
    this.trackRotateClick('image_rotate_btn')
  }

  handleBrightness(e) {
    const brightness = parseFloat(e.target.value)
    this.setState({
      brightness: brightness,
      editMade: true,
      getNewFeedback: true,
    })
    this.props.handleEditMade(true)
    this.canvasFilterStyle = `brightness(${brightness}) contrast(${this.state.contrast})`
    this.debounceDynamicFeedback()
    this.trackBrightness('image_brightness_adjusted')
  }

  handleContrast(e) {
    const contrast = parseFloat(e.target.value)
    this.setState({ contrast: contrast, editMade: true, getNewFeedback: true })
    this.props.handleEditMade(true)
    this.canvasFilterStyle = `brightness(${this.state.brightness}) contrast(${contrast})`
    this.debounceDynamicFeedback()
    this.trackContrast('image_contrast_adjusted')
  }

  handleReset(includeImage = true) {
    const { resetImage } = this.props
    const zoomSlider = document.getElementById('zoom-slider')
    const straightenSlider = document.getElementById('straighten-slider')
    const brightnessSlider = document.getElementById('brightness-slider')
    const contrastSlider = document.getElementById('contrast-slider')
    
    if (zoomSlider) zoomSlider.value = '1'
    if (straightenSlider) straightenSlider.value = '0'
    if (brightnessSlider) brightnessSlider.value = '1'
    if (contrastSlider) contrastSlider.value = '1'
    this.straightenerValue = 0
    this.props.handleEditMade(false)
    this.initialFeedbackToShow = true
    if (includeImage) {
      resetImage()
    }
    this.setState(
      {
        editMade: false,
        resetClicked: true,
      },
      () => {
        this.currentFeedback = this.getFeedbackTiles(true)
      }
    )
    this.featuresNotDetected = this.initialFeaturesNotDetected
    this.setState({
      rotate: 0,
      scale: 1,
      brightness: 1,
      contrast: 1,
      getNewFeedback: false,
    })
    this.trackReset('reset_btn_clicked')
  }

  handleClick() {
    const { uploading } = this.props
    if (!uploading) {
      this.formPhoto.value = ''
      $(this.formPhoto).trigger('click')
    }
    this.trackChangePhoto('change_photo_clicked')
  }

  handleFile(e) {
    const { handleFileChange, intl } = this.props
    var reader = new FileReader()
    var file = e.target.files[0]
    if (!file) {
      return
    }
    let pictureName = null,
      pictureSize = null,
      pictureType = null

    if (file) {
      pictureName = file.name
      pictureSize = file.size
      pictureType = file.type
    }
    const notifyErrorOptions = { timeout: 10000 }
    if (pictureName) {
    }
    if (pictureSize) {
      if (pictureSize > 8388608) {
        notification(
          intl.formatMessage({
            id: 'aspire.imageEditor.failedUploadFileSizeExceeds',
            defaultMessage: 'Failed to upload file. File size exceeds 8MB.',
          }),
          'error'
        )
        this.trackNotifyError('upload_picture_exceeds_size')
        this.formPhoto.value = ''
        this.setState({
          isUploaded: false,
        })
        return
      }
      if (pictureSize < 1024) {
        notification(
          intl.formatMessage({
            id: 'aspire.imageEditor.failedUploadFileSizeSubceeds',
            defaultMessage: 'Failed to upload file. File size subceeds 1KB.',
          }),
          'error'
        )
        this.trackNotifyError('upload_picture_subceeds_size')
        this.formPhoto.value = ''
        this.setState({
          isUploaded: false,
        })
        return
      }
    }

    const fileTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const invalidFileMessage = intl.formatMessage({
      id: 'aspire.imageEditor.fileTypeNotSupported',
      defaultMessage: 'The file type is not supported. Please choose an image.',
    })
    if (fileTypes.indexOf(pictureType) === -1) {
      notification(invalidFileMessage, 'error')
      this.trackNotifyError('upload_failed_not_image_type')
      this.formPhoto.value = ''
      this.setState({
        isUploaded: false,
      })
      return
    }
    this.setState({
      isUploaded: true,
    })
    reader.onload = function (img) {
      handleFileChange(img.target.result)
    }.bind(this)
    reader.readAsDataURL(file)
    this.handleReset(false)
    setTimeout(() => {
      this.getDynamicFeedback()
    }, 1000)
    this.trackNewPhotoAdded('change_photo_submit')
  }

  getSliderBackgroundStyle(element) {
    let width = 0
    switch (element) {
      case 'zoom':
        width = ((parseFloat(this.state.scale) - 0.9) / 2.1) * 100
        break
      case 'straighten':
        width = ((parseFloat(this.straightenerValue) + 45) / 90) * 100
        break
      case 'brightness':
        width = (parseFloat(this.state.brightness) - 0.5) * 100
        break
      case 'contrast':
        width = (parseFloat(this.state.contrast) - 0.5) * 100
        break
    }
    return `linear-gradient(to right, #0075cb 0%,#0075cb ${width}%,#dadada ${width}%,#dadada 100%)`
  }

  handleSave() {
    const { handleSaveChanges, imageData } = this.props
    const { uploading_image, uploaded_image } = imageData

    if (this.state.getNewFeedback || (uploading_image && !uploaded_image)) {
      setTimeout(() => {
        handleSaveChanges()
      }, 2000)
    } else {
      handleSaveChanges()
    }
    this.setState({ editMade: false, getNewFeedback: false })
    this.props.handleEditMade(false)
  }

  closeEditModal() {
    const {
      onRequestHide,
      hideEditModal,
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
    if (_.isNull(this.state.editMade)) {
      onRequestHide()
    } else if (this.state.resetClicked) {
      hideEditModal(
        'profile_picture',
        currentIndex,
        sectionWiseTextStatic,
        sectionWiseTextStatic,
        false
      )
    } else {
      hideEditModal(
        'profile_picture',
        currentIndex,
        sectionWiseTextEditable,
        sectionWiseTextStatic,
        this.state.editMade
      )
    }
  }

  toggleInfoBox(parameter) {
    let keyName = parameter + '_open'
    let isOpen = this.state[parameter + '_open']
    this.setState({
      [keyName]: !isOpen,
    })
  }

  getFeedbackTiles(isInitialFeedback = 0, isNoImg = 0) {
    const { imageData, hideSmileAndFBRatio, user, feedback, intl } = this.props
    const { editMade, resetClicked } = this.state
    const { community } = user
    let emptyImagedata = {
      face_frame_ratio: { color_feedback: 'red' },
      face_body_ratio: { color_feedback: 'red' },
      background: { color_feedback: 'red' },
      pupil: { color_feedback: 'red' },
      foreground: { color_feedback: 'red' },
      smile: { color_feedback: 'red' },
    }
    let imageDataClass = {
      face_frame_ratio: { className: 'face-frame-ratio-green-desc' },
      face_body_ratio: { className: 'face-body-ratio-green-desc' },
      background: { className: 'background-green-desc' },
      pupil: { className: 'pupil-green-desc' },
      foreground: { className: 'foreground-green-desc' },
      smile: { className: 'smile-green-desc' },
    }
    let imgData = isNoImg
      ? emptyImagedata
      : editMade
      ? imageData
      : isInitialFeedback
      ? feedback
      : imageData
    let params = [
      ['face_frame_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
      ['face_body_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceBodyRatio', defaultMessage: 'Face/Body Ratio' })],
      ['background', intl.formatMessage({ id: 'aspire.imageEditor.backgroundIllumination', defaultMessage: 'Background Illumination' })],
      ['pupil', intl.formatMessage({ id: 'aspire.imageEditor.eyeContact', defaultMessage: 'Eye Contact' })],
      ['foreground', intl.formatMessage({ id: 'aspire.imageEditor.foregroundIllumination', defaultMessage: 'Foreground Illumination' })],
      ['smile', intl.formatMessage({ id: 'aspire.imageEditor.smileDetection', defaultMessage: 'Smile Detection' })],
    ]
    if (community === 'ensign') {
      params = [
        ['face_frame_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
        ['face_body_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceBodyRatio', defaultMessage: 'Face/Body Ratio' })],
        ['pupil', intl.formatMessage({ id: 'aspire.imageEditor.eyeContact', defaultMessage: 'Eye Contact' })],
        ['foreground', intl.formatMessage({ id: 'aspire.imageEditor.foregroundIllumination', defaultMessage: 'Foreground Illumination' })],
        ['smile', intl.formatMessage({ id: 'aspire.imageEditor.smileDetection', defaultMessage: 'Smile Detection' })],
      ]
    }
    if (hideSmileAndFBRatio) {
      params = [
        ['face_frame_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
        ['foreground', intl.formatMessage({ id: 'aspire.imageEditor.foregroundIllumination', defaultMessage: 'Foreground Illumination' })],
        ['background', intl.formatMessage({ id: 'aspire.imageEditor.backgroundIllumination', defaultMessage: 'Background Illumination' })],
        ['pupil', intl.formatMessage({ id: 'aspire.imageEditor.eyeContact', defaultMessage: 'Eye Contact' })],
      ]
      if (community === 'ensign') {
        params = [
          ['face_frame_ratio', intl.formatMessage({ id: 'aspire.imageEditor.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
          ['foreground', intl.formatMessage({ id: 'aspire.imageEditor.foregroundIllumination', defaultMessage: 'Foreground Illumination' })],
          ['pupil', intl.formatMessage({ id: 'aspire.imageEditor.eyeContact', defaultMessage: 'Eye Contact' })],
        ]
      }
    }
    let output = {
      detected: [],
      not_detected: [],
    }
    let outputOrder = {
      green: [],
      yellow: [],
      red: [],
    }
    this.featuresNotDetected = false
    _.map(params, (value, key) => {
      if (
        _.isEmpty(imgData[value[0]]) ||
        _.isUndefined(imgData[value[0]]['color_feedback'])
      ) {
        this.featuresNotDetected = true
      } else {
        let isOpen = this.state[value[0] + '_open']
        outputOrder[imgData[value[0]]['color_feedback']].push(
          <div
            className={`as-picture-feedback-tile edit-picture-feedback-tile edit-picture-feedback-tile-${
              imgData[value[0]]['color_feedback']
            }`}
            onClick={() => this.toggleInfoBox(value[0])}>
            <div className="profile-picture-status-info">
              <div className="feedback-parameter-status-icon">
                <img
                  alt=""
                  src={`${process.env.APP_BASE_URL}dist/images/${
                    iconMap[imgData[value[0]]['color_feedback']]
                  }`}
                  className="feedback-parameter-icon"
                  width="20"
                  height="20"
                />
              </div>
              {value[1]}
            </div>
            {imgData[value[0]]['color_feedback'] !== 'green' ? (
              <div className="profile-picture-status-desc">
                {feedbackMap(intl)[value[0]][imgData[value[0]]['color_feedback']]}
              </div>
            ) : (
              <div
                className={`profile-picture-status-desc ${
                  imageDataClass[value[0]]['className']
                } ${
                  isOpen
                    ? 'profile-picture-status-desc-open'
                    : 'profile-picture-status-desc-close'
                }`}>
                {feedbackMap(intl)[value[0]][imgData[value[0]]['color_feedback']]}
              </div>
            )}
          </div>
        )
      }
    })
    output['detected'] = output['detected'].concat(outputOrder['red'])
    output['detected'] = output['detected'].concat(outputOrder['yellow'])
    output['detected'] = output['detected'].concat(outputOrder['green'])
    return output['detected']
  }

  renderDynamicFeedback() {
    const { imageData, feedback, isOpen } = this.props
    if (!isOpen) {
      this.currentFeedback = null
    }
    const { uploading_image, uploaded_image } = imageData

    if (uploaded_image) {
      this.currentFeedback = this.getFeedbackTiles()
      this.initialFeedbackToShow = false
    }
    if (this.initialFeedbackToShow) {
      this.featuresNotDetected = this.initialFeaturesNotDetected
    }
  }
  
  handleImgInfoClose() {
    this.setState({
      isUploaded: true,
    })
  }

  render() {
    const {
      img,
      isOpen,
      onRequestHide,
      feedback,
      savingChanges,
      imageData,
      focusDisable,
      hideSmileAndFBRatio,
      initialState,
      updateState,
      profileData,
      intl,
    } = this.props
    const { isUploaded } = this.state
    const { uploading_image, saving_image } = imageData
    if (!isOpen) {
      return null
    }
    let loaderEl = <div className="loader-line"></div>
    let reactAvatorCanvasFilter = `brightness(${this.state.brightness}) contrast(${this.state.contrast})`
    let zoomBackgroundStyle = this.getSliderBackgroundStyle('zoom')
    let straightenBackgroundStyle = this.getSliderBackgroundStyle('straighten')
    let brightnessBackgroundStyle = this.getSliderBackgroundStyle('brightness')
    let contrastBackgroundStyle = this.getSliderBackgroundStyle('contrast')
    this.renderDynamicFeedback()
    let saveButton = (
      <button
        aria-label={editModalAriaLabel(intl)['apply']}
        className="btn btn-primary apply-btn"
        onClick={this.handleSave}>
        {intl.formatMessage({
          id: 'aspire.imageEditor.save',
          defaultMessage: 'Save',
        })}
      </button>
    )
    if (uploading_image || this.state.getNewFeedback || saving_image) {
      saveButton = (
        <button
          aria-label={editModalAriaLabel(intl)['loading_feedback']}
          className="btn btn-primary apply-btn cusrsor-not-allowed"
          disabled>
          {intl.formatMessage({
            id: 'aspire.imageEditor.save',
            defaultMessage: 'Save',
          })}
        </button>
      )
    } else if (savingChanges) {
      saveButton = (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['saving']}
          className="btn btn-primary apply-btn cusrsor-not-allowed"
          disabled>
          {intl.formatMessage({
            id: 'aspire.imageEditor.saving',
            defaultMessage: 'Saving ...',
          })}
        </button>
      )
    } else if (
      this.state.resetClicked ||
      !this.state.editMade ||
      (!_.isUndefined(img) && !isUploaded)
    ) {
      saveButton = (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['no_change_made']}
          className="btn btn-primary apply-btn cusrsor-not-allowed"
          disabled>
          {intl.formatMessage({
            id: 'aspire.imageEditor.save',
            defaultMessage: 'Save',
          })}
        </button>
      )
    }
    let resetButton = (
      <button
        className="btn reset-btn"
        aria-label={editModalAriaLabel(intl)['reset']}
        onClick={this.handleReset}>
        {intl.formatMessage({
          id: 'aspire.imageEditor.reset',
          defaultMessage: 'Reset',
        })}
      </button>
    )
    if (!this.state.editMade) {
      resetButton = (
        <button
          className="btn reset-btn cursor-not-allowed"
          aria-label={editModalAriaLabel(intl)['no_change_made']}
          disabled>
          {intl.formatMessage({
            id: 'aspire.imageEditor.reset',
            defaultMessage: 'Reset',
          })}
        </button>
      )
    }
    if (this.state.resetClicked) {
      this.featuresNotDetected = this.initialFeaturesNotDetected
    }
    let disabled = savingChanges || _.isUndefined(img)
    let imgIncorrectMessage = (
      <div className="img-incorrect">
        <div className="close-div">
          <div
            className="btn-close float-end"
            onClick={this.handleImgInfoClose}>
            <img
              src={`${process.env.APP_BASE_URL}dist/images/edit-screens/icon-close.svg`}
              height="14px"
              width="14px"
              alt="close-image"
            />
          </div>
        </div>
        <div className="img-div">
          <img
            src={`${process.env.APP_BASE_URL}dist/images/edit-screens/profile-pic-alert.svg`}
            height="124px"
            width="126px"
            alt="info-image"
          />
        </div>
        <div className="desc-card">
          <div className="desc-header">
            {intl.formatMessage({
              id: 'aspire.imageEditor.incorrectProfilePictureHeader',
              defaultMessage: 'Incorrect profile picture has been uploaded',
            })}
          </div>
          <div className="desc-li-content">
            <div className="desc-li">
              <span className="desc-img">
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/icon-needs-work.svg`}
                  height="16px"
                  width="16px"
                  alt="error-image"
                />
              </span>
              {intl.formatMessage({
                id: 'aspire.imageEditor.maximumFileSize',
                defaultMessage: 'Maximum File Size:',
              })}
              &nbsp;
              <span className="bold-text">
                {intl.formatMessage({
                  id: 'aspire.imageEditor.maximumFileSizeValue',
                  defaultMessage: '8MB',
                })}
              </span>
              &nbsp;
            </div>
            <div className="desc-li">
              <span className="desc-img">
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/icon-needs-work.svg`}
                  height="16px"
                  width="16px"
                  alt="error-image"
                />
              </span>
              {intl.formatMessage({
                id: 'aspire.imageEditor.minimumFileSize',
                defaultMessage: 'Minimum File Size:',
              })}
              &nbsp;
              <span className="bold-text">
                {intl.formatMessage({
                  id: 'aspire.imageEditor.minimumFileSizeValue',
                  defaultMessage: '1Kb',
                })}
              </span>
            </div>
            <div className="desc-li">
              <span className="desc-img">
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/icon-needs-work.svg`}
                  height="16px"
                  width="16px"
                  alt="error-image"
                />
              </span>
              {intl.formatMessage({
                id: 'aspire.imageEditor.supportedFileFormats',
                defaultMessage: 'File Formats Supported:',
              })}
              &nbsp;
              <span className="bold-text">
                {intl.formatMessage({
                  id: 'aspire.imageEditor.supportedFileFormatsValue',
                  defaultMessage: 'JPEG, JPG, and PNG only',
                })}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
    let imageAbsent = _.isUndefined(img) || _.isNull(img)
    return (
      <>
        <div
          className={`row as-eq-height-row as-profile-eq scroll-hidden as-profile-eq-height-footer`}>
          <div className="col-sm-4 profile-pic-edit-left left-container">
            <div
              className={classNames(
                'dynamic-feedback-container',
                uploading_image ? 'dynamic-feedback-loader' : '',
                { 'padding-t-40': hideSmileAndFBRatio }
              )}
              tabIndex="0">
              <div className="dynamic-feedback-container-heading-wrapper">
                <div className="dynamic-feedback-container-heading">
                  {intl.formatMessage({
                    id: 'aspire.imageEditor.profilePhotoFeedbackHeading',
                    defaultMessage: 'Profile Photo Feedback',
                  })}
                </div>
                <div
                  className="dynamic-feedback-container-info"
                  onClick={(e) => {
                    updateState(0)
                  }}>
                  {intl.formatMessage({
                    id: 'aspire.imageEditor.knowMore',
                    defaultMessage: 'Know more',
                  })}
                </div>
              </div>
              {!imageAbsent
                ? this.currentFeedback
                : this.getFeedbackTiles(false, true)}
              {loaderEl}
              {this.featuresNotDetected ? (
                <div className="text-red red-info-msg-detect">
                  {intl.formatMessage({
                    id: 'aspire.imageEditor.unableToDetectFeatures',
                    defaultMessage: '* Unable to detect other features.',
                  })}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-sm-8 profile-pic-edit-right right-container">
            <div className="profile-picture-canvas-edit-div">
              <div className="profile-picture-edit-div">
                <div
                  className={`picture-canvas-container ${
                    !isUploaded ? 'picture-canvas-incorrect' : ''
                  }`}
                  id="picture-canvas-container">
                  {_.isUndefined(img) ? (
                    <>
                      {isUploaded ? (
                        <div className="as-picture-sample-img-container">
                          <div className="as-picture-bg-color" />
                          <div className="as-edit-img">
                            <img
                              src={`${process.env.APP_BASE_URL}dist/images/profile-avatar.png`}
                              className="edit-img-circular"
                              width="200"
                              height="200"
                              alt="Your profile picture"
                            />
                          </div>
                        </div>
                      ) : (
                        imgIncorrectMessage
                      )}
                    </>
                  ) : (
                    <>
                      {isUploaded ? (
                        <>
                          <div className="canvas-grid-container-top"></div>
                          <div className="canvas-grid-container">
                            <div className="canvas-grid-container-top-horizontal" />
                            <div className="canvas-grid-container-bottom-horizontal" />
                            <div className="canvas-grid-container-left-vertical" />
                            <div className="canvas-grid-container-right-vertical" />
                          </div>
                          {!_.isEmpty(profileData.imageUrl) && (
                            <div className="download-photo-container">
                              <img
                                src={`${process.env.APP_BASE_URL}dist/images/ic_download.svg`}
                                className="download-button"
                                alt="Download Button"
                                onClick={() => {
                                  this.downloadImage(profileData.imageUrl)
                                }}
                              />
                            </div>
                          )}
                          <ReactAvatarEditor
                            className="reactAvatorCanvasStyle"
                            ref={this.setEditorRef}
                            border={[150, 50]}
                            scale={parseFloat(this.state.scale)}
                            width={this.state.width}
                            height={this.state.height}
                            style={{
                              width: '100%',
                              height: `${this.state.containerHeight}px`,
                              marginBottom: '-2px',
                            }}
                            position={this.state.position}
                            onPositionChange={this.handlePositionChange}
                            rotate={parseFloat(this.state.rotate)}
                            borderRadius={this.state.borderRadius}
                            onSave={this.handleSave}
                            image={img}
                            filters={reactAvatorCanvasFilter}
                            disabled={disabled}
                          />
                          <div className="canvas-grid-container-bottom"></div>
                        </>
                      ) : (
                        imgIncorrectMessage
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="profile-picture-panel-div">
                <div
                  className="edit-profile-picture-wrapper"
                  id="edit-profile-picture-modal">
                  <div className="edit-profile-picture-crop">
                    <div className="edit-profile-picture-crop-heading edit-profile-picture-action-heading">
                      <span>
                        <img
                          src={`${process.env.APP_BASE_URL}dist/images/edit-screens/profile-picture-crop.svg`}
                          alt="crop icon"
                          width="18"
                          height="18"
                        />
                      </span>
                      <span className="panel-tab-heading-text">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.crop',
                          defaultMessage: 'Crop',
                        })}
                      </span>
                    </div>
                    <div className="edit-profile-picture-crop-actions edit-profile-picture-action-actions">
                      <div className="edit-profile-picture-crop-actions-subheading1 edit-profile-picture-action-subheading1">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.zoom',
                          defaultMessage: 'Zoom',
                        })}
                      </div>
                      <div className="edit-profile-picture-crop-actions-func edit-profile-picture-action-func-slide">
                        <input
                          className="edit-picture-slider"
                          aria-label="slider to zoom in your profile photo"
                          id="zoom-slider"
                          name="scale"
                          type="range"
                          onChange={this.handleScale}
                          min="0.9"
                          max="3"
                          step="0.01"
                          defaultValue="1"
                          style={{
                            background: zoomBackgroundStyle,
                          }}
                          disabled={disabled || imageAbsent}
                        />
                      </div>
                      <div className="edit-profile-picture-crop-actions-subheading1 edit-profile-picture-action-subheading1">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.straighten',
                          defaultMessage: 'Straighten',
                        })}
                      </div>
                      <div className="edit-profile-picture-crop-actions-func edit-profile-picture-action-func-slide">
                        <input
                          className="edit-picture-slider"
                          aria-label="slider to rotate your profile picture"
                          id="straighten-slider"
                          name="scale"
                          type="range"
                          onChange={this.handleRotateStraighten}
                          min="-45"
                          max="45"
                          step="0.5"
                          defaultValue="0"
                          style={{
                            background: straightenBackgroundStyle,
                          }}
                          disabled={disabled || imageAbsent}
                        />
                      </div>
                      <div className="edit-profile-picture-crop-actions-subheading2">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.rotate',
                          defaultMessage: 'Rotate',
                        })}
                      </div>
                      <div className="crop-actions-rotate-div">
                        <div className="crop-actions-rotate-clock">
                          <button
                            className="rotate-btn"
                            disabled={disabled || imageAbsent}
                            onClick={() => this.handleRotate('left')}>
                            <img
                              className="rotate-img"
                              src={`${process.env.APP_BASE_URL}dist/images/edit-screens/rotate-left.svg`}
                              alt="rotate left"
                            />
                            {intl.formatMessage({
                              id: 'aspire.imageEditor.anticlockwise',
                              defaultMessage: 'Anticlockwise',
                            })}
                          </button>
                        </div>
                        <div className="crop-actions-rotate-clock">
                          <button
                            className="rotate-btn"
                            disabled={disabled || imageAbsent}
                            onClick={() => this.handleRotate('right')}>
                            <img
                              className="rotate-img"
                              src={`${process.env.APP_BASE_URL}dist/images/edit-screens/rotate-right.svg`}
                              alt="rotate right"
                            />
                            {intl.formatMessage({
                              id: 'aspire.imageEditor.clockwise',
                              defaultMessage: 'Clockwise',
                            })}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="edit-profile-picture-illumination">
                    <div className="edit-profile-picture-bright-heading edit-profile-picture-action-heading">
                      <span>
                        <img
                          src={`${process.env.APP_BASE_URL}dist/images/edit-screens/profile-picture-illumination.svg`}
                          alt="illuination icon"
                          width="22"
                          height="22"
                        />
                      </span>
                      <span className="panel-tab-heading-text">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.illumination',
                          defaultMessage: 'Illumination',
                        })}
                      </span>
                    </div>
                    <div className="edit-profile-picture-bright-actions edit-profile-picture-action-actions">
                      <div className="edit-profile-picture-bright-actions-subheading1 edit-profile-picture-action-subheading1">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.brightness',
                          defaultMessage: 'Brightness',
                        })}
                      </div>
                      <div className="edit-profile-picture-bright-actions-func edit-profile-picture-action-func-slide">
                        <input
                          className="edit-picture-slider"
                          aria-label="slider to increase decrease brightness"
                          id="brightness-slider"
                          name="scale"
                          type="range"
                          onChange={this.handleBrightness}
                          min="0.5"
                          max="1.5"
                          step="0.01"
                          defaultValue="1"
                          style={{
                            background: brightnessBackgroundStyle,
                          }}
                          disabled={disabled || imageAbsent}
                        />
                      </div>
                      <div className="edit-profile-picture-bright-actions-subheading1 edit-profile-picture-action-subheading1">
                        {intl.formatMessage({
                          id: 'aspire.imageEditor.contrast',
                          defaultMessage: 'Contrast',
                        })}
                      </div>
                      <div className="edit-profile-picture-bright-actions-func edit-profile-picture-action-func-slide">
                        <input
                          className="edit-picture-slider"
                          aria-label="slider to increase decrease contrast"
                          id="contrast-slider"
                          name="scale"
                          type="range"
                          onChange={this.handleContrast}
                          min="0.5"
                          max="1.5"
                          step="0.01"
                          defaultValue="1"
                          style={{
                            background: contrastBackgroundStyle,
                          }}
                          disabled={disabled || imageAbsent}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="profile-pic-change-photo-btn">
              <button
                className="btn change-photo-btn"
                onClick={(e) => this.handleClick(e)}>
                <span className="change-photo-text">
                  {_.isUndefined(img)
                    ? intl.formatMessage({
                        id: 'aspire.imageEditor.uploadPhoto',
                        defaultMessage: 'Upload Photo',
                      })
                    : intl.formatMessage({
                        id: 'aspire.imageEditor.changePhoto',
                        defaultMessage: 'Change Photo',
                      })}
                </span>
              </button>
              <form method="post" ref={(c) => (this.form = c)}>
                <input
                  type="file"
                  name="profile_picture"
                  accept="image/*"
                  className="visually-hidden hide-it"
                  ref={(c) => (this.formPhoto = c)}
                  onChange={this.handleFile}
                  aria-label="input field to change picture"
                />
              </form>
            </div>
          </div>
        </div>
        <div className="as-profile-edit-footer">
          <div className="set-reset-profile-btn">
            {resetButton}
            {saveButton}
          </div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    imageData: state.imageData,
    user: state.user.data,
    profileData: state.detailedFeedbackUi.sectionWiseText,
  }
}
export default connect(mapStateToProps, {
  dynamicImageFeedback,
  changeProfilePicInitialEditState,
  downloadImage,
})(injectIntl(ImageEditor))
